import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import ProjectCard from '../ProjectCard';
import './projects.scss';

import projectPng from '../../assets/images/projects/png/p-6.png';
import projectWebp from '../../assets/images/projects/webp/p-6.webp';

const Projects = () => {
    const { t } = useTranslation();

    return (
        <section className="featured-project" id="featured-project">
            <div className="container">
                <div className="row section-separator">
                    <div className="section-title col-sm-12 text-center" data-aos="fade-up">
                        <h3>
                            <FontAwesomeIcon icon={faLaptopCode} /> {t('Projects.Title')}
                        </h3>
                    </div>
                    <div className="col-sm-12 col-md-10 offset-md-1">
                        <div className="project-details">
                            <ProjectCard
                                png={projectPng}
                                webp={projectWebp}
                                projectName={t('Projects.Featured.Name')}
                                projectURL="https://unitashumanitas.com"
                                tag={t('Projects.Featured.Tag')}
                                subname={t('Projects.Featured.Subname')}
                                infos={t('Projects.Featured.Infos')}
                                technologies={[
                                    'React',
                                    'PayloadCMS',
                                    'Next.js',
                                    'Azure',
                                    'Terraform',
                                    'GitHub Actions',
                                    'i18n (FR/EN)',
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Projects;
